var DealPages;
(function (DealPages) {
    DealPages["SEARCH"] = "Search";
    DealPages["HOME"] = "Homepage";
    DealPages["CATEGORY"] = "Category";
    DealPages["PERK"] = "Perk";
})(DealPages || (DealPages = {}));
export default DealPages;
